/* Shared product carousel behaviour (owner 2026-10-04: reuse the home page's oil carousel wherever products show).
   Same logic as the inline scripts in sections/ap-homepage-rebuild-v2.liquid, under the same global guards so the two
   never double-bind on one page:
   - size picker on .pcard cards (updates the hidden variant id, price and compare-at);
   - [data-oils-carousel] prev/next buttons + their disabled states;
   - quick add: [data-ap-setup-form] inside .ap-pcar posts to /cart/add.js (the AP cart drawer intercepts the add and
     opens). On failure the form submits normally, so the shopper still reaches the cart. */
(function () {
  if (!window.__apVariantPickerBound) {
    window.__apVariantPickerBound = true;
    document.addEventListener('click', function (e) {
      var pill = e.target.closest('.pcard__variant'); if (!pill) return;
      if (pill.getAttribute('aria-disabled') === 'true') return;
      var card = pill.closest('.pcard'); if (!card) return;
      var pills = card.querySelectorAll('.pcard__variant');
      for (var i = 0; i < pills.length; i++) pills[i].classList.remove('is-active');
      pill.classList.add('is-active');
      var idIn = card.querySelector('[data-ap-vid]'); if (idIn) idIn.value = pill.getAttribute('data-vid');
      var pv = card.querySelector('[data-ap-price]'); if (pv) pv.textContent = pill.getAttribute('data-price') || '';
      var cmp = card.querySelector('[data-ap-compare]');
      if (cmp) { var c = pill.getAttribute('data-compare') || ''; cmp.textContent = c; cmp.hidden = !c; }
      // The % badge follows the chosen size (it showed the first variant's discount, e.g. -33% on a 240ml at -62%).
      var badge = card.querySelector('[data-ap-card-badge]');
      if (badge) {
        var d = pill.getAttribute('data-discount');
        badge.textContent = d ? '\u2212' + d + '%' : (badge.getAttribute('data-default-label') || '');
        badge.hidden = !badge.textContent;
      }
    });
  }

  if (!window.__apOilsCarouselBound) {
    window.__apOilsCarouselBound = true;
    var upd = function (track) {
      var root = track.closest('[data-oils-carousel]'); if (!root) return;
      var max = track.scrollWidth - track.clientWidth - 4;
      var prev = root.querySelector('[data-oils-prev]'), next = root.querySelector('[data-oils-next]');
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = (track.scrollLeft >= max) || (max <= 4);
    };
    var by = function (track, dir) {
      track.style.scrollSnapType = 'none';
      track.scrollBy({ left: dir * Math.round(track.clientWidth * 0.85), behavior: 'smooth' });
      clearTimeout(track.__snapT);
      track.__snapT = setTimeout(function () { track.style.scrollSnapType = ''; upd(track); }, 600);
    };
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-oils-prev],[data-oils-next]'); if (!btn) return;
      var root = btn.closest('[data-oils-carousel]'); if (!root) return;
      var track = root.querySelector('[data-oils-track]'); if (!track) return;
      by(track, btn.hasAttribute('data-oils-next') ? 1 : -1);
    });
    // Carousels with data-pcar-size (e.g. the hub's 240ml Restock row) open each card on that size by selecting the
    // card's own size pill, so price, compare-at and the add-to-cart variant all follow (owner 2026-10-05).
    var sizeRail = function (rail, want) {
      var cards = rail.querySelectorAll('.pcard');
      for (var c = 0; c < cards.length; c++) {
        var pills = cards[c].querySelectorAll('.pcard__variant');
        for (var k = 0; k < pills.length; k++) {
          if (pills[k].textContent.trim() === want && !pills[k].classList.contains('is-oos')) {
            if (!pills[k].classList.contains('is-active')) pills[k].click();
            break;
          }
        }
      }
      var btns = rail.querySelectorAll('[data-pcar-size-btn]');
      for (var b = 0; b < btns.length; b++) btns[b].setAttribute('aria-pressed', btns[b].getAttribute('data-pcar-size-btn') === want ? 'true' : 'false');
    };
    // Size switch above a carousel ([data-pcar-sizes]): one tap sets every card. The hub's #restock link (refill / VIP
    // emails, "See the math") opens the best-seller carousel on 240ml.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pcar-size-btn]'); if (!btn) return;
      var rail = btn.closest('.ap-pcar'); if (rail) sizeRail(rail, btn.getAttribute('data-pcar-size-btn'));
    });
    var restockHash = function () {
      if (location.hash !== '#restock') return;
      var sw = document.querySelector('.ap-pcar [data-pcar-sizes]');
      if (sw) sizeRail(sw.closest('.ap-pcar'), '240ml');
    };
    window.addEventListener('hashchange', restockHash);
    var presize = function () {
      restockHash();
      var rails = document.querySelectorAll('.ap-pcar[data-pcar-size]');
      for (var r = 0; r < rails.length; r++) {
        var want = rails[r].getAttribute('data-pcar-size');
        var cards = rails[r].querySelectorAll('.pcard');
        for (var c = 0; c < cards.length; c++) {
          var pills = cards[c].querySelectorAll('.pcard__variant');
          for (var k = 0; k < pills.length; k++) {
            if (pills[k].textContent.trim() === want && !pills[k].classList.contains('is-oos')) {
              if (!pills[k].classList.contains('is-active')) pills[k].click();
              break;
            }
          }
        }
      }
    };
    var initAll = function () {
      presize();
      var tracks = document.querySelectorAll('[data-oils-track]');
      for (var i = 0; i < tracks.length; i++) {
        (function (track) {
          if (track.__apCarBound) return; track.__apCarBound = true;
          track.addEventListener('scroll', function () { upd(track); }, { passive: true });
          upd(track);
        })(tracks[i]);
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    window.addEventListener('resize', function () { var t = document.querySelectorAll('[data-oils-track]'); for (var i = 0; i < t.length; i++) upd(t[i]); });
    window.setTimeout(initAll, 1500);
  }

  if (!window.__apPcarAddBound) {
    window.__apPcarAddBound = true;
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.ap-pcar [data-ap-setup-form]'); if (!form || !window.fetch) return;
      event.preventDefault();
      var button = form.querySelector('[data-ap-setup-atc]');
      if (button) { button.disabled = true; button.classList.add('is-loading'); }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          if (button) { button.classList.remove('is-loading'); button.classList.add('is-added'); }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('ap:cart:add'));
          window.setTimeout(function () { if (!button) return; button.disabled = false; button.classList.remove('is-added'); }, 1600);
        }).catch(function () { if (button) button.classList.remove('is-loading'); form.submit(); });
    });
  }
}());
